<medpace-page>
    <div class="flex flex-col gap-medpace items-center">
        @if (isSuccess()) {
            <medpace-alert [content]="'Request has been sent successfully.'" [appearance]="'highlight'" />
        }

        @if (!isSuccess()) {
            <mds-card>
                <mds-card-content class="gap-medpace w-[400px]">
                    <h3>{{ title }}</h3>
                    <div class="pt-8">
                        <h5>Email Address</h5>
                        <p>{{ email }}</p>
                    </div>

                    <form #ngForm="ngForm" [formGroup]="formGroup">
                        <div class="flex flex-col gap-medpace pt-8">
                            <mds-dropdown
                                [closeOnPageScroll]="false"
                                [formCtrl]="formGroup.controls.userAccessGroup"
                                [id]="'userAccessGroupField'"
                                [appearance]="'outline'"
                                [placeholder]="'Select access level'"
                                [label]="'Access Level'"
                                [options]="accessLevels"
                            ></mds-dropdown>
                            @if (isAssistant()) {
                                <div class="o-grid__row">
                                    <div class="o-grid__field">
                                        <medpace-alert content="Specify Study details." [appearance]="'highlight'" />
                                    </div>
                                </div>
                            }
                            <mds-textarea
                                [formCtrl]="formGroup.controls.justification"
                                [id]="'justification'"
                                [placeholder]="'Type here...'"
                                [appearance]="'outline'"
                                [label]="'Justification'"
                            >
                            </mds-textarea>
                        </div>
                    </form>
                </mds-card-content>
                <mds-card-actions>
                    <mds-button
                        [label]="'Send'"
                        [color]="'primary'"
                        [variant]="'filled'"
                        [id]="'sendBtn'"
                        (clickEvent)="sendRequest()"
                    />
                </mds-card-actions>
            </mds-card>
        }
    </div>

    @if (isLoading()) {
        <medpace-loading />
    }
</medpace-page>
